<template>
<div class="desk_box">
    <div class="function_desk flex_box" :style="
    {
        'right':this.right+'px',
        'bottom':this.bottom+'px'
    }
    " ref="desk">
        <div class="hb_type flex_box">
            <div class="hb"><i></i><span>{{$t("Brush")}}</span><i></i></div>
            <div class="free_lasso"><i></i><span>{{$t("Lasso")}}</span></div>
            <div class="line_lasso"><i></i><span>{{$t("Polygonal")}}</span></div>
            <div class="eraser"><i></i><span>{{$t("Eraser")}}</span><i></i></div>
            <i class="dashed"></i>
        </div>
        <div class="crop_box flex_box">
            <i class="back_remove"></i>
            <i class="dashed"></i>
            <div class="cropOperateBox">
                {{$t("AspectRatio")}}
                <div class="chose-res">
                <p style="display: inline-block;">{{$t("Free")}}</p>
                <i></i>
                <div class="sizeList-box">
                    <ul class="sizeList">
                        <li class="set-crop-ratio show-res" data-ratio-width="0" data-ratio-height="100">{{$t("Free")}}</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="1" data-ratio-height="1">1:1</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="1" data-ratio-height="2">1:2</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="2" data-ratio-height="1">2:1</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="2" data-ratio-height="3">2:3</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="3" data-ratio-height="2">3:2</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="3" data-ratio-height="4">3:4</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="4" data-ratio-height="3">4:3</li>
                        <li class="no-border set-crop-ratio show-res" data-ratio-width="9" data-ratio-height="16">9:16</li>
                    </ul>
                </div>
                </div>
            </div>
            <i class="dashed"></i>
        </div>
        <div class="revoke_box">
            <i class="undo"></i>
            <i class="redo"></i>
        </div>
        <div class="zoom_box">
            <i class="enlarge"></i>
            <span class="scaleValue">0%</span>
            <i class="narrow"></i>
        </div>
        <i class="move"></i>
        <i class="dashed"></i>
        <span class="remove">{{$t("Remove")}}<div class="remove_guide">{{$t("removeTip")}}</div></span>
        <i class="move_box"
            @mousedown="this.dragDiv($event)"
        ></i>
        <!-- 画笔大小 -->
        <span class="pensize-change-container">
            <span class="pen-title">{{$t("BrushSize")}}</span>
            <div class="pensize-box blue-border">
                <div class="pensize-grey-box"></div>
                <p class="pensize-dot"></p>
            </div>
            <input type="text" class="pen-value" value="16">
            <!-- <div class="penColor">
                <i data="rgba(255,0,0,0.5)" style="background:red;"></i>
                <i data="rgba(255,255,0,0.5)" style="background:yellow;"></i>
                <i data="rgba(0,0,255,0.5)" style="background:blue;"></i>
                <i data="rgba(0,128,0,0.5)" style="background:green;"></i>
            </div> -->
            <i></i>
        </span>
    </div>
    <div class="function_desk_mobile">
        <div class="top flex_box">
            <div class="revoke_box">
                <i class="undo"></i>
                <i class="redo"></i>
            </div>
            <div class="zoom_box">
                <i class="enlarge"></i>
                <span class="scaleValue">0%</span>
                <i class="narrow"></i>
            </div>
            <i class="move"></i>
        </div>
        <div class="bottom">
            <div class="hb_type flex_box">
                <div class="hb_mobile active"><i></i><span>{{$t("Brush")}}</span></div>
                <div class="free_lasso"><i></i><span>{{$t("Lasso")}}</span></div>
                <div class="eraser"><i></i><span>{{$t("Eraser")}}</span></div>
                <span class="remove">{{$t("Remove")}}<div class="remove_guide">{{$t("removeTip")}}</div></span>
            </div>
            <div class="crop_box flex_box">
                <div class="cropOperateBox flex_box">
                    <i class="back_remove"></i>
                    <i class="dashed"></i>
                    <span>{{$t("AspectRatio")}}</span>
                    <div class="chose-res">
                    <p style="display: inline-block;">{{$t("Free")}}</p>
                    <i></i>
                    <div class="sizeList-box">
                        <ul class="sizeList">
                        <li class="set-crop-ratio show-res" data-ratio-width="0" data-ratio-height="100">{{$t("Free")}}</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="1" data-ratio-height="1">1:1</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="1" data-ratio-height="2">1:2</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="2" data-ratio-height="1">2:1</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="2" data-ratio-height="3">2:3</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="3" data-ratio-height="2">3:2</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="3" data-ratio-height="4">3:4</li>
                        <li class="set-crop-ratio show-res" data-ratio-width="4" data-ratio-height="3">4:3</li>
                        <li class="no-border set-crop-ratio show-res" data-ratio-width="9" data-ratio-height="16">9:16</li>
                        </ul>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 画笔大小 -->
        <span class="pensize-change-container">
            <span class="pen-title">{{$t("BrushSize")}}</span>
            <div class="pensize-box blue-border">
                <div class="pensize-grey-box"></div>
                <p class="pensize-dot"></p>
            </div>
            <input type="text" class="pen-value" value="16">
            <!-- <div class="penColor">
                <i data="rgba(255,0,0,0.5)" style="background:red;"></i>
                <i data="rgba(255,255,0,0.5)" style="background:yellow;"></i>
                <i data="rgba(0,0,255,0.5)" style="background:blue;"></i>
                <i data="rgba(0,128,0,0.5)" style="background:green;"></i>
            </div> -->
            <i></i>
        </span>
    </div>
</div>
</template>

<script scoped>
export default {
    data(){
        return{
            right:24,
            bottom:24
        }
    },
    mounted(){
        $('.edit_btn').addClass('active');
        $('.function_desk').addClass('active')
        this.right=$(window).width()-$('.function_desk').offset().left-$('.function_desk').width()+$('.edit_btn').width()-20
        $('.function_desk').css({
            right:this.right
        });
        $('.edit_btn').removeClass('active');
        $('.function_desk').removeClass('active')
        var that=this;
        $(window).resize(function(){
            if(that.bottom>editInfo.offsetHeight-that.$refs.desk.offsetHeight){
                that.bottom=editInfo.offsetHeight-that.$refs.desk.offsetHeight;
            }
            $('.function_desk').css({right:0});
            var deskW=that.$refs.desk.offsetWidth;
            $('.function_desk').css({right:that.right});
            if(that.right>=editInfo.offsetWidth-deskW-1){
                that.right=editInfo.offsetWidth-deskW-1
            }
        });
    },
    methods:{
        dragDiv(e){
            var that=this;
            if(parseInt($('.function_desk').css("right"))!=that.right){
                that.right=parseInt($('.function_desk').css("right"))
            }
            var dx=e.clientX+that.right
            var dy=e.clientY+that.bottom
            document.onmousemove=function(e){
                var right=dx-e.clientX;
                var bottom=dy-e.clientY;
                if(right<0){
                    that.right=0;
                }else if(right>=editInfo.offsetWidth-that.$refs.desk.offsetWidth){
                    that.right=editInfo.offsetWidth-that.$refs.desk.offsetWidth-1
                }
                else{
                    that.right=right;
                }
                if(bottom<0){
                    that.bottom=0
                }else if(bottom>editInfo.offsetHeight-that.$refs.desk.offsetHeight){
                    that.bottom=editInfo.offsetHeight-that.$refs.desk.offsetHeight;
                }else{
                    that.bottom=bottom;
                }
            }
            document.onmouseup=function(){
                document.onmousemove=null;
            }
        }
    }
}
</script>

<style scoped>
    .function_desk>*{
        margin: 0 8px;
    }
    .function_desk *{
        vertical-align: middle;
    }
    .function_desk{
        position: fixed;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(166, 166, 166, 0.3);
        border-radius: 8px;
        height: 60px;
        padding-left: 16px;
        padding-right: 24px;
        justify-content: flex-start;
        align-items: center;
        font-size: 16px;
        display: none;
        z-index: 1;
    }
    .function_desk.active{
        display: flex;
        flex-wrap: nowrap;
    }
    .function_desk .dashed,.cropOperateBox .dashed{
        width: 0px !important;
        height: 16px !important;
        border-left: 1px dashed #D5D5D5;
        margin: 0 8px;
    }
    .function_desk .hb_type{
        margin-left: 0px;
        align-items: center;
    }
    .function_desk .hb_type div{
        cursor: pointer;
    }
    .desk_box .hb_type i{
        background: url(../assets/images/lasso.png);
        width: 24px;
        height: 24px;
    }
    .desk_box .hb_type .hb,.desk_box .hb_type .hb_mobile{
        margin-left: 0px;
    }
    .desk_box .hb_type .hb i,.desk_box .hb_type .hb_mobile i{
        background: url(../assets/images/brush.svg);
    }
    .desk_box .hb_type .hb.active i,.desk_box .hb_type .hb_mobile.active i{
        background: url(../assets/images/brush-h.svg);
    }
    .desk_box .hb_type .free_lasso i{
        background: url(../assets/images/lasso.svg);
    }
    .desk_box .hb_type .free_lasso.active i{
        background: url(../assets/images/lasso-h.svg);
    }
    .desk_box .hb_type .line_lasso i{
        background: url(../assets/images/polygonal.svg);
    }
    .desk_box .hb_type .line_lasso.active i{
        background: url(../assets/images/polygonal-h.svg);
    }
    .desk_box .hb_type .eraser i{
        background: url(../assets/images/eraser.svg);
    }
    .desk_box .hb_type .eraser.active i{
        background: url(../assets/images/eraser-h.svg);
    }
    .function_desk .hb_type div{
        margin: 0 9px;
        height: 28px;
        line-height: 26px;
        text-align: center;
        border: 1px solid transparent;
        border-radius: 18px;
    }
    .function_desk .hb_type div.active{
        padding-left: 12px;
        padding-right: 12px;
        border-color: #21a1f2;
    }
    .function_desk .hb_type div span{
        display: none;
    }
    .function_desk .hb_type div.active span{
        display: inline-block;
        color: #21a1f2;
    }
    .function_desk .revoke_box{
        margin: 0px;
    }
    .desk_box .revoke_box i{
        background: url(../assets/images/back-icon.png);
        width: 20px;
        height: 20px;
        margin: 0 9px;
        cursor: pointer;
    }
    .desk_box .revoke_box i.undo{
        background: url(../assets/images/undo.svg);
    }
    .desk_box .revoke_box i.undo:hover{
        background: url(../assets/images/undo-h.svg);
    }
    .desk_box .revoke_box i.undo.active{
        background: url(../assets/images/undo-h.svg);
    }
    .desk_box .revoke_box i.undo.forbid{
        background: url(../assets/images/undo-f.svg);
    }
    .desk_box .revoke_box i.redo{
        background: url(../assets/images/redo.svg);
    }
    .desk_box .revoke_box i.redo:hover{
        background: url(../assets/images/redo-h.svg);
    }
    .desk_box .revoke_box i.redo.active{
        background: url(../assets/images/redo-h.svg);
    }
    .desk_box .revoke_box i.redo.forbid{
        background: url(../assets/images/redo-f.svg);
    }
    .desk_box .zoom_box{
        margin: 0px;
    }
    .desk_box .zoom_box i{
        background: url(../assets/images/bar.png);
        width: 24px;
        height: 24px;
        margin: 0 6px;
        cursor: pointer;
    }
    .desk_box .zoom_box span{
        line-height: 24px;
        color: #333;
    }
    .desk_box .zoom_box i.enlarge{
        background: url(../assets/images/enlarge.svg);
    }
    .desk_box .zoom_box i.enlarge.forbid{
        background: url(../assets/images/enlarge-forbid.svg);
    }
    .desk_box .zoom_box i.narrow{
        background: url(../assets/images/narrow.svg);
    }
    .desk_box .zoom_box i.narrow.forbid{
        background: url(../assets/images/narrow-forbid.svg);
    }
    .desk_box .move{
        background: url(../assets/images/move.svg);
        width: 24px;
        height: 24px;
        cursor: pointer;
    }
    .desk_box .move.active{
        background: url(../assets/images/move-h.svg);
    }
    .function_desk .remove{
        min-width: 88px;
        height: 28px;
        line-height: 28px;
        background: #21a1f2;
        border-radius: 4px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        position: relative;
    }
    .function_desk .remove:hover{
        background: #33c3f3;
    }
    .remove_guide{
        position: absolute;
        width: 370px;
        padding: 20px 150px 20px 20px;
        box-sizing: border-box;
        box-shadow: 0px 4px 18px 0px rgb(123 123 123 / 39%);
        border-radius: 18px;
        background: #FBFBFB url(../assets/images/bg2.png) no-repeat right bottom;
        margin: 0;
        color: #222;
        text-align: left;
        font-size: 14px;
        line-height: 24px;
        display: none;
    }
    .remove_guide.active{
        display: block;
    }
    .remove_guide::after{
        clear: both;
        content: "";
        width: 69px;
        height: 77px;
        background: url(../assets/images/arrow-guide.png);
        position: absolute;
        right: 40px;
    }
    .function_desk  .move_box{
        background: url(../assets/images/bar.png);
        width: 24px;
        height: 24px;
        background-position-y: -216px;
        cursor: pointer;
        margin-top: -48px;
        margin-right: -30px;
        zoom:.7;
        position: relative;
    }
    .function_desk  .move_box::after{
        clear: both;
        content: "";
        position: absolute;
        left: -10px;
        top: -8px;
        height: 88px;
        width: 40px;
    }

    .function_desk .crop_box{
        display: none;
        align-items: center;
    }
    .desk_box .back_remove{
        width: 24px;
        height: 24px;
        background: url(../assets/images/back.svg);
        cursor: pointer;
    }
    .function_desk .crop_box.active{display: block;}
    .function_desk .crop_box>.dashed:last-child{
        margin-right: 0px;
        margin-left: 16px;
    }
    .function_desk .crop_box>span.active{
        border-color: #21a1f2;
        color: #21a1f2;
    }
    .function_desk .crop_box>span{
        line-height: 26px;
        border: 1px solid transparent;
        padding-left: 8px;
        padding-right: 8px;
        font-size: 16px;
        color: #333;
        border-radius: 18px;
        min-width: 62px;
        text-align: center;
        box-sizing: border-box;
        display: inline-block;
        cursor: pointer;
    }
    .function_desk .cropOperateBox{
        margin-left: 24px;
        display: inline-block;
        font-size: 16px;
    }
    .function_desk .cropOperateBox .sizeList-box{
        display: none;
    }
    .sizeList-box{
        display: none;
        width: 84px;
        position: absolute;
        bottom: 30px;
        left: -1px;
        z-index: 999;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 0px 9px rgba(15,35,119,0.26);
    }
    .sizeList {
        width: 84px;
        list-style: none;
        overflow: hidden;
        background-color: #fff;
        color: #485062;
    }
    .sizeList-scroll-bar{
        position: absolute;
        width: 3px;
        /* height: 86.4px; */
        height: 126px;
        background-color: #c5d7ff;
        top: 4;
        right: 2px;
        z-index: 1000;
    }
    /* .sizeList-scroll-bar:hover{
        background-color: #305ab8;
    } */

    .sizeList.active i {
        background-position: 0 -6px;
    }

    .sizeList li {
        width: 100%;
        font-size: 14px;
        line-height: 24px;
        cursor: pointer;
        padding-left: 10px;
        box-sizing: border-box;
    }
    .sizeList li:hover{
        color: white;
        background-color: #21a1f2;
    }

    .function_desk .cropOperateBox .chose-res{
        display: inline-block;
        line-height: 26px;
        min-width: 86px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .chose-res{
        border-radius: 4px;
        margin-left: 8px;
        padding-left: 8px;
        padding-right: 20px;
        position: relative;
        border: 1px solid #333;
        color: #333;
    }
    .chose-res i{
        display: inline-block;
        width: 12px;
        height: 6px;
        position: absolute;
        top: 11px;
        right: 6px;
        background-image: url(../assets/images/combox-arrow.png);
        background-position: 0 0px;
        background-repeat: no-repeat;
    }
    .chose-res:hover{
        border: 1px solid #21a1f2;
        color: #21a1f2;
    }
    .chose-res:hover i{
        background-position: 0 -7px;
    }
    .chose-res.active i{
        background-position: 0 -14px;
    }
    .chose-res.active:hover i{
        background-position: 0 -21px;
    }
    .hb_type .hb i:last-child,.hb_type .eraser i:last-child{
        display: none;
    }
    .hb_type .hb.active i:last-child,.hb_type .eraser.active i:last-child{
        display: inline-block;
        width: 8px;
        height: 5px;
        background: url(../assets/images/arrow-1.png);
        margin-left: 5px;
        background-position-y: -5px;
    }
    .hb_type .hb.active.c i:last-child,.hb_type .erase.active.c i:last-child{
        background-position-y: -0px;
    }
    .pensize-change-container{
        margin: 0 !important;
        cursor: default !important;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0, 0, 0, .3);
        padding:5px 10px;
        position: absolute;
        top: 50px;
        z-index: 3;
    }
    .pensize-change-container *{
        vertical-align: middle;
    }
    .pensize-change-container i{width: 16px;height: 16px;background: url(../assets/images/arrow1.svg);display: inline-block;margin-left: 5px;cursor: pointer;}
    .pensize-change-container input {
        width: 30px;
        text-align: center;
        margin-left: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
        cursor: pointer;
    }
    .penColor{
        display: inline-block;
        margin-top: -2px;
        margin-right: 10px;
    }
    .penColor i{
        width: 16px;
        height: 16px;
    }
    .pensize-change-container .pensize-box{
        position: relative;
        width: 180px;
        height: 10px;
        border: #D9D9D9 !important;
        overflow: visible !important;
        cursor: pointer; 
        display: inline-block;
        margin-left: 20px;
    }
    .pensize-change-container .pensize-grey-box{
        width: 100%;
        height: 2px;
        background-color: #D9D9D9;
        margin-top: 3px;
    }
    .pensize-change-container .pensize-dot{
        position: absolute;
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #21a1f2;
        z-index: 10;
        border-radius: 100%;
        top: 0px;
        left: 16px;
        box-shadow: 0 0 4px 1px #21a1f2;
    }
    .scaleValue{min-width: 41px;display: inline-block;text-align: center;}

    .function_desk_mobile{display: none;}
    @media screen and (max-width:980px){
        .function_desk{display: none !important;}
        .function_desk_mobile{
            position: fixed;
            bottom: 0px;
            left: 0px;
            width: 100%;
            box-sizing: border-box;
        }
        .function_desk_mobile.active{display: block;}
        .function_desk_mobile .top{
            padding-top: 20px;
            justify-content: center;
            padding-bottom: 12px;
            background: #F0F7FE;
        }
        .function_desk_mobile .top *{
            vertical-align: middle;
        }
        .function_desk_mobile .top i{
            margin-left: 6px;
            margin-right: 6px;
        }
        .function_desk_mobile .bottom{
            padding: 12px 16px;
            box-shadow: 0px 2px 12px rgba(166, 166, 166, 0.3);
            background: #fff;
        }
        .function_desk_mobile .hb_type{
            justify-content: space-around;
            align-items: center;
        }
        .function_desk_mobile .hb_type div{
            text-align: center;
            font-size: 14px;
        }
        .function_desk_mobile .hb_type div i{
            display: block;
            margin: auto;
        }
        .function_desk_mobile .hb_type div.active{
            color: #21a1f2;
        }
        .function_desk_mobile .hb_type .remove{
            min-width: 70px;
            line-height: 28px;
            background: #21a1f2;
            border-radius: 4px;
            padding:0 10px;
            box-sizing: border-box;
            font-size: 14px;
            color: #fff;
            text-align: center;
            position: relative;
        }
        .function_desk_mobile .crop_box{
            display: none;
        }
        .function_desk_mobile .crop_box.active{
            display: flex;
            width: 100%;
            height: 46px;
            align-items: center;
        }
        .chose-res{
            width: 84px;
            box-sizing: border-box;
            border: 1px solid #1e1e1e !important;
            color: #1e1e1e !important;
        }
        .chose-res i{
            background-position-y: 0px !important;
            top: 8px;
        }
        .cropOperateBox{
            width: 100%;
            align-items: center;
            justify-content: center;
        }
        .pensize-change-container{
            top: 0px;
        }
        .remove_guide{
            top: unset !important;
            bottom: 90px !important;
            right: -20px !important;
            text-align: left !important;
            color: #333 !important;
            padding-right: 100px;
            max-width: 320px;
        }
        .pensize-change-container *{
            font-size: 14px;
        }
    }
    @media screen and (max-width:500px){
        .pensize-change-container .pensize-box{
            width: 100px;
        }
    }
</style>